import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckLoading } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles(theme => ({
  primaryColor: {
    color: theme.palette.primary.main
  }
}));

const ListoParaEntregarIcon = (props = {}) => {
  const classes = useStyles();

  const size = props.fontSize === "large" ? "2x" : "1x";
  const color = props.color === "primary" ? classes.primaryColor : "";

  return <FontAwesomeIcon icon={faTruckLoading} size={size} className={color} />;
};

export default ListoParaEntregarIcon;
